import type {FC} from 'react';
import {PageTabConstants} from '../../../../core/entities/clip/constants';
import {PageTabForMobileItem} from './PageTabForMobileItem';

export const PageTabForMobile: FC = () => {
  return (
    <ul className="flex h-48 w-full bg-background-1 pb-8">
      {Object.entries(PageTabConstants.URL).map(([key, url]) => (
        <PageTabForMobileItem key={key} keyName={key} url={url} />
      ))}
    </ul>
  );
};
